<template>
  <TemplateModal ref="modal" center width="750" :sendFunction="onSendOffer" :key="key">
    <template v-slot:activator>
      <BaseButton default_icon="button-send" round icon_only @click="openModal()" />
    </template>
    <div class="send">
      <div>
        <label class="font-weight-bold primary--text">{{ localStorage.translations.pages.common.text.receiver }}</label>
        <div class="my-2">
          <v-btn
            v-for="(email, i) in receiver_email"
            :key="i"
            rounded
            small
            depressed
            style="text-transform: none"
            class="primary--text"
            :class="Number(i) > 0 ? 'ml-2' : ''"
            @click="editEmail(i)"
          >
            {{ email }}
            <v-hover v-slot="{ hover }">
              <v-icon
                @click.stop="delEmail(i)"
                size="16"
                class="pa-2 mr-n2"
                :color="hover ? 'red' : ''"
              >
                mdi-close
              </v-icon>
            </v-hover>
          </v-btn>
        </div>
        <v-form ref="email_form" lazy-validation>
          <v-text-field
            ref="qq"
            validate-on-blur
            v-model="item"
            outlined
            v-on:keyup.space="addEmailSpace"
            @input="inputEmail"
            :error="error"
            append-outer-icon="mdi-plus-thick"
            @click:append-outer="addEmailClick"
            :rules="rule ? [inputRules.required, inputRules.email] : []"
          />
        </v-form>
      </div>
      <BaseInput
        :label="localStorage.translations.pages.common.text.sender"
        v-model="sender_email"
        :rules="['required', 'max100', 'email']"
      >
        <template slot="append-outer">
          <BaseIcon class="btn-pt" icon="button-save" color="transparent" />
        </template>
      </BaseInput>
      <BaseInput
        :label="localStorage.translations.pages.common.text['mail_title']"
        v-model="subject"
        readonly
        :rules="['required']"
      >
        <template slot="append-outer">
          <BaseIcon class="btn-pt" icon="button-save" color="transparent" />
        </template>
      </BaseInput>
      <BaseInput
        :label="localStorage.translations.pages.chat.all.message"
        v-model="allData.project_offer_email_text.value"
        type="textarea"
        :rules="['required']"
        @input="message_disable=false"
      >
        <template slot="append-outer">
          <v-btn
           color="primary"
           class="btn-pt"
           depressed
           :disabled="!navigationGuardianActive == true && message_disable == false
             ? !navigationGuardianActive && (message_disable = true)
             : message_disable"
           @click="prepareData(allData.project_offer_email_text)"
          >
            <BaseIcon width="20" height="20" icon="button-save" />
          </v-btn>
        </template>
      </BaseInput>
      <BaseInput
        :label="localStorage.translations.pages.common.buttons.sign"
        v-model="allData.project_offer_email_sign.value"
        type="textarea"
        :rules="['required']"
        @input="sign_disable=false"
      >
        <template slot="append-outer">
          <v-btn
           color="primary"
           class="btn-pt"
           depressed
           :disabled="!navigationGuardianActive == true && sign_disable == false
             ? !navigationGuardianActive && (sign_disable = true)
             : sign_disable"
           @click="prepareData(allData.project_offer_email_sign)"
          >
            <BaseIcon width="20" height="20" icon="button-save" />
          </v-btn>
        </template>
      </BaseInput>
    </div>
    <template v-slot:submit>
      <BaseButton
        :text="
          !loading
            ? localStorage.translations.pages.common.buttons.send
            : Math.trunc(loadingProgress) + '%'
        "
        @click="prepareAllData(allData)"
        type="submit"
        default_icon="button-send"
        :active="loading"
        :round="loading"
        :loading="loading"
      />
    </template>
  </TemplateModal>
</template>

<script>
import TemplateModal from 'components/templates/TemplateModal'
import { mapActions, mapGetters, mapState } from 'vuex'

import BaseButton from 'components/base/BaseButton.vue'

export default {
  name: 'ProjectProposedModal',
  props: {
    edit: Boolean,
    project: [Object, Array],
    person: [Object, Array],
    textTheme: String,
    fileSend: [File, Blob, String],
    functionGeneratePdf: Function,
  },
  components: {
    BaseButton,
    TemplateModal,
  },
  data: () => ({
    key: 0,
    loading: false,
    loadingProgress: 0,
    dialog: false,
    fileUrl: null,
    receiver_email: [],
    sender_email: null,
    list: [],
    item: '',
    error: false,
    rule: false,
    fieldsLabels: ['project_offer_email_text', 'project_offer_email_sign'],
    subject: '',
    allData: {
      project_offer_email_text: {
        name: 'project_offer_email_text',
        value: '',
      },
      project_offer_email_sign: {
        name: 'project_offer_email_sign',
        value: '',
      },
    },
    message_disable: true,
    sign_disable: true,
  }),
  created() {
    this.getTemplateContentData()
    this.receiver_email.push(this.person.email)
    this.key++
  },

  computed: {
    ...mapState(['configData']),
    ...mapGetters('user', ['userData']),
    ...mapGetters(['apiDomain', 'inputRules']),
    ...mapGetters('commonContent', ['contentData', 'allContentData', 'categoryContentData']),
    ...mapGetters('navigationGuardian', ['navigationGuardianActive']),
  },
  watch: {
    '$refs.modal.dialog'() {
      if (this.$refs.modal && this.$refs.modal.dialog) {
        this.$forceUpdate()
      }
    },
    '$route.name'() {
      this.onCheckChange({ overwrite: true })
    },
    allData: {
      handler() {
        this.onCheckChange({ overwrite: false })
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions('workClient', ['onWorkClientSendOffer']),
    ...mapActions('commonContent', ['onGetContentData', 'onGetCategoryContent', 'onChangeContentData']),
    ...mapActions('navigationGuardian', ['onNavigationGuardianCheck']),
    openModal() {
      this.$refs.modal.openModal()
      this.sender_email = this.userData.email
      this.subject = this.textTheme
    },
    async getTemplateContentData() {
      let data = {
        category: 'project_offer_email',
        contentable_type: 'project',
        contentable_id: this.$route.params.id,
      }
      await this.onGetCategoryContent(data).then((res) => {
        let temp = res.data.data.map((i) => i.name)
        for (let i in this.fieldsLabels) {
          let index = temp.indexOf(this.fieldsLabels[i])
          this.allData[this.fieldsLabels[i]].value = res.data.data[index].value
        }
        this.onCheckChange({ overwrite: true })
      })
    },
    prepareData(data) {
      let result = {
        content: [
          {
            category: 'project_offer_email',
            name: data.name,
            value: data.value,
          },
        ],
        contentable_type: 'project',
        contentable_id: this.$route.params.id,
      }
      this.updateData(result)
    },
    prepareAllData(data) {
      let result = {
        content: [
          {
            category: 'project_offer_email',
            name: Object.values(data)[0].name,
            value: Object.values(data)[0].value,
          },
          {
            category: 'project_offer_email',
            name: Object.values(data)[1].name,
            value: Object.values(data)[1].value,
          },
        ],
        contentable_type: 'project',
        contentable_id: this.$route.params.id,
      }
      let multi_field = true
      this.updateData(result, multi_field)
    },
    async updateData(data) {
      this.message_disable = true
      this.sign_disable = true
      await this.onChangeContentData(data)
       .then(() => {
         this.getTemplateContentData()
         this.onSave()
       })
       .catch((err) => {
         console.log(err)
         this.$store.dispatch(
          'popup/onMessage',
          {
            message: this.localStorage.translations.pages.common.notifications['oshibka'],
            IsError: true,
          },
          { root: true },
         )
       })
    },
    async submitFile() {
      let formData = new FormData()
      formData.append('file', this.fileSend, this.textTheme)
      await this.$store
        .dispatch('uploadFile', {
          data: formData,
        })
        .then((response) => {
          this.fileUrl = response.data.url
        })
        .catch()
    },
    async onSendOffer() {
      if (this.$refs.modal.validate()) {
        if (this.receiver_email.length < 1) {
          this.$refs.qq.focus()
          this.error = true
        } else {
          this.loadingProgress = 0
          this.loading = true
          if (!this.fileSend) {
            await this.functionGeneratePdf()
          }
          this.loadingProgress = 50
          await this.submitFile()
          this.loadingProgress = 70
          let dataSend = {
            sender_email: this.sender_email,
            sender_name: this.sender_email,
            receiver_emails: this.receiver_email,
            subject: this.subject,
            message: this.allData.project_offer_email_text.value,
            info: this.allData.project_offer_email_sign.value,
            file: this.fileUrl,
            language_id: this.localStorage.translations.language_id,
          }
          this.onWorkClientSendOffer(dataSend)
            .then(() => {
              this.$store.dispatch(
                'popup/onMessage',
                {
                  message:
                    this.localStorage.translations.pages.common.notifications['sent_successfully'],
                  IsError: false,
                },

                { root: true },
              )
              this.loadingProgress = 70
              this.loading = false
              this.$refs.modal.closeModal()
            })
            .catch(() => {
              this.$store.dispatch(
                'popup/onMessage',
                {
                  message: this.localStorage.translations.pages.common.notifications['oshibka'],
                  IsError: true,
                },
                { root: true },
              )
              this.loading = false
            })
        }
      }
    },
    onCheckChange({ overwrite }) {
      this.onNavigationGuardianCheck({
        data: { projectLetterOfferSettings: this.allData },
        overwrite,
      })
    },
    onSave() {
     
        this.onNavigationGuardianCheck({
          data: { projectLetterOfferSettings: this.allData },
          overwrite: true,
        })
        this.edit = false
        document.body.scrollTop = 0 // For Safari
        document.documentElement.scrollTop = 0 // For Chrome, Firefox, IE and Opera
      
    },
    addEmailSpace() {
      if (this.$refs.email_form.validate()) {
        if (Number(this.receiver_email.indexOf(this.item.slice(0, -1))) < 0) {
          this.receiver_email.push(this.item.slice(0, -1))
        }
        this.item = ''
        this.rule = false
      } else this.error = true
    },
    inputEmail() {
      this.error = false
      this.rule = true
    },
    addEmailClick() {
      if (this.item.length > 0) {
        if (this.$refs.email_form.validate()) {
          if (Number(this.receiver_email.indexOf(this.item)) < 0) {
            this.receiver_email.push(this.item)
          }
          this.item = ''
          this.rule = false
        } else this.error = true
      } else {
        this.error = true
        this.rule = true
        this.$refs.qq.focus()
      }
    },
    delEmail(id) {
      this.receiver_email.splice(id, 1)
      this.$refs.qq.focus()
    },
    editEmail(id) {
      this.item = this.receiver_email[id]
      this.receiver_email.splice(id, 1)
      this.rule = true
    },
  },
}
</script>

<style lang="scss" scoped>
.send {
  width: 100%;
  display: grid;
  row-gap: 20px;
}
.btn-pt {
  height: 30px !important;
  padding: 0 !important;
  min-width: 30px !important;
}
</style>